<div [ngClass]="commonService.isHidden ? '' : 'subheadFullview'" class="subhead d-flex align-items-center">
  <h5 class="mr-3 mt-2">Project</h5>
  <ng-form class="form-group" class="ngFormcls" style="z-index: 1;">
    <select class="form-control" style="width:33vh;z-index:4; cursor: pointer;" [(ngModel)]="selectedOption" [ngModelOptions]="{standalone: true}"
      (change)="changeProject()">
      <option *ngFor="let option of options" [value]="option.id">{{
        option?.projectName }}</option>
    </select>
  </ng-form>
</div>